<template>
  <div
    class="backList"
    @touchstart.stop="touchstart"
    @touchmove.stop="touchmove"
    @touchend.stop="touchend"
    ref="scrollAdd"
  >
    <div class="backList-box" v-for="(item, index) in list" :key="item.Id">
      <div
        class="backList-box-top"
        :class="{bottomBorder: openIndex == index}"
        @click="routerOrShow(item.ChildCount, index, item.Id)"
      >
        <div class="backList-box-code">
          <span class="backList-box-label">职权名称：</span>
        </div>
        <div class="backList-box-title">{{item.Name}}</div>
        <div class="backList-box-num">{{item.ChildCount | numFilter}}</div>
      </div>
      <div class="backList-box-btn" v-if="!!item.Code">
        <div class="backList-box-btn-label">
          <span class="backList-box-label">职权编号：</span>
        </div>
        <div class="backList-box-btn-content">{{item.Code}}</div>
      </div>
      <div class="backList-box-btn" v-if="!!item.ImplementingAgency">
        <div class="backList-box-btn-label">
          <span class="backList-box-label">实施机构：</span>
        </div>
        <div class="backList-box-btn-content">{{item.ImplementingAgency}}</div>
      </div>
      <transition-group name="bounce" tag="div">
        <div
          class="backList-box-children"
          :class="{bottomBorder: childIndex < item.ChildCount-1}"
          v-for="(child,childIndex) in item.ChildList"
          :key="child.Id"
          v-show="openIndex == index"
        >
          <div class="backList-box-top">
            <div class="backList-box-child-code">
              <span class="backList-box-label backList-box-child-label">{{child.Code}}</span>
            </div>
            <div
              class="backList-box-title"
              @click="routerOrShow(-1, childIndex, child.Id)"
            >{{child.Name}}</div>
          </div>
          <!-- <div v-if="!!child.Code" class="backList-box-btn">
            <div class="backList-box-btn-label">
              <span class="backList-box-label">职权编号：</span>
            </div>
            <div class="backList-box-btn-content">{{child.Code}}</div>
          </div>-->
        </div>
      </transition-group>
    </div>
    <transition name="bounce">
      <div class="loading_add" v-show="loading">
        <img src="./../assets/loading.png" />
        <!-- <span class="iconfont icon-jiazai1-copy-copy"></span> -->
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    rolesList: {
      type: Array,
      default: function() {
        return [];
      }
    }
    // nowPage: {
    //   type: Number,
    //   default: 1
    // },
    // deptId: {
    //   type: Number,
    //   default: -1
    // },
    // affairTypeId: {
    //   type: Number,
    //   default: -1
    // },
    // keyword: {
    //   type: String,
    //   default: ""
    // }
  },
  data() {
    return {
      flag: false,
      openIndex: -1,
      // childList: [],
      beginY: 0,
      loading: false,
      list: []
    };
  },
  methods: {
    routerOrShow(len, index, id) {
      if (len > 0) {
        if (this.openIndex == index) {
          this.openIndex = -1;
        } else {
          this.openIndex = index;
        }
      } else {
        this.$router.push({
          path: "bilityInfos",
          query: {
            id: id
          }
        });
      }
    },
    touchstart(e) {
      let touch = e.changedTouches[0];
      this.beginY = touch.clientY;
    },
    touchmove() {
      let scrollTop = this.$refs.scrollAdd.scrollTop;
      let clientHeight = this.$refs.scrollAdd.clientHeight;
      let scrollHeight = this.$refs.scrollAdd.scrollHeight;
      let bottomHeight = scrollHeight - clientHeight - scrollTop;
      if (bottomHeight == 0 && this.list.length > 0 && scrollTop > 0) {
        this.loading = true;
      }
    },
    touchend(e) {
      let endTouch = e.changedTouches[0];
      if (this.beginY > endTouch.clientY) {
        if (this.loading) {
          this.getNewList();
        }
      }
    },
    getNewList() {
      this.$emit("getnewlist");
    }
  },
  filters: {
    numFilter: function(value) {
      if (value > 0) {
        return value + "项子项";
      } else {
        return "无子项";
      }
    }
  },
  watch: {
    rolesList(newValue, oldValue) {
      // this.list = this.list.concat(newValue);
      this.openIndex = -1;
      this.list = this.rolesList;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.backList {
  width: 100%;
  height: calc(100vh - 10rem);
  position: relative;
  padding: 0.25rem 0;
  overflow: auto;
  .backList-box {
    width: 100%;
    height: auto;
    // border: 1px solid #bdc3c7;
    padding: 0.25rem 0;
    // border-radius: 0.5rem;
    margin: 0.25rem 0;
    box-shadow: 0rem 0.32rem 0rem 0rem rgba(179, 179, 179, 0.17);
    .backList-box-top {
      width: 100%;
      height: auto;
      display: flex;
      padding: 0.5rem 1rem;
      border-bottom: 1px solid rgba(179, 179, 179, 0.17);
      // flex-wrap: wrap;
      .backList-box-code {
        min-width: 5rem;
        font-size: 0.7rem;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          height: 0.8rem;
          left: -0.25rem;
          margin: auto;
          width: 0.2rem;
          z-index: 20;
          background-color: #e22519;
        }
      }
      .backList-box-num {
        min-width: 3rem;
        font-size: 0.75rem;
        text-align: right;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #6b6b6b;
      }
      .backList-box-title {
        width: 100%;
        line-height: 1rem;
        // height: 2rem;
        font-size: 0.75rem;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-all;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        color: #6b6b6b;
        // white-space: nowrap;
      }
    }
    .backList-box-btn {
      width: 100%;
      // height: 1.25rem;
      line-height: 1rem;
      font-size: 0.7rem;
      text-align: left;
      // text-indent: 0.5em;
      // padding-top: 0.25rem;
      padding: 0 1rem;
      margin-top: 0.25rem;
      // border-top: 1px dashed #cccccc;
      display: flex;
      .backList-box-btn-label {
        min-width: 5rem;
        font-size: 0.7rem;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .backList-box-btn-content {
        width: 100%;
        line-height: 1rem;
        // height: 2rem;
        font-size: 0.75rem;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-all;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        color: #6b6b6b;
        // white-space: nowrap;
      }
    }
    .backList-box-children {
      width: 100%;
      height: auto;
      padding-left: 1rem;
      padding: 0.5rem 0rem 0.5rem 1.5rem;
      .backList-box-top {
        padding: 0.25rem 0;
        flex-wrap: nowrap;
      }

      .backList-box-child-code {
        min-width: 5rem;
        font-size: 0.7rem;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &::after {
          content: "";
          width: 0.2rem;
          height: 0.2rem;
          background-color: #999999;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          z-index: 50;
          border-radius: 0.2rem;
        }
      }
      .backList-box-code {
        min-width: 5rem;
        font-size: 0.7rem;
      }
      .backList-box-title {
        width: auto;
        line-height: 1rem;
      }
      .backList-box-btn {
        padding: 0;
      }
    }
  }
  .bottomBorder {
    border-bottom: 1px solid #cccccc;
  }
  .backList-box-label {
    color: #999999;
    font-size: 0.75rem;
    display: block;
    text-align: left;
    width: 100%;
    text-indent: 0.5em;
  }
  .backList-box-child-label {
    margin: 0 0.25rem;
  }
}
.bounce-enter-active {
  animation: bounce-in 0.25s;
  animation-fill-mode: both;
}
.bounce-leave-active {
  animation: bounce-in 0.25s reverse;
  animation-fill-mode: both;
}
@keyframes bounce-in {
  0% {
    height: 0;
    opacity: 0;
  }
  100% {
    height: auto;
    opacity: 1;
  }
}
</style>